<template>
	<div class="w-100 shadow bg-white border-15" 
	v-if="dashboard_user"
	:style="(windowWidth>=1000) ? 'padding: 32px;' : 'padding: 16px;'"
	>
	<div class=" d-flex" style="justify-content: space-between;" v-if="windowWidth>=1300">
		<div class="w-100" style="padding-left: 8px;">
			<div
			class="w-100"
			style="background: #6767671A; padding: 11px; border-radius: 20px;"
			>
				<b style="font-size: 24px; color: #414042;">
					{{ dashboard_user.numbers.duration_of_cooperation }}
				</b>
				<span style="font-size: 10px; color: #676767;">
					روز
				</span>
				<br>
				<span style="font-size: 12px;">
					مدت زمان همکاری شما
				</span>
			</div>
		</div>
		<!-- **************************************************** -->
		<div class="w-100" style="padding-left: 8px;">
			<div
			class="w-100"
			style="background: #FFF7E9; padding: 11px; border-radius: 20px;"
			>
				<b style="font-size: 24px; color: #F59B05;">
					{{ dashboard_user.numbers.total_number_of_students }}
				</b>
				<br>
				<span style="font-size: 12px;">
					تعداد کل کاربر‌های شما
				</span>
			</div>
		</div>
		<!-- **************************************************** -->
		<div class="w-100" style="padding-left: 8px;">
			<div
			class="w-100"
			style="background: #EAF1F5; padding: 11px; border-radius: 20px;"
			>
				<b style="font-size: 24px; color: #257393;">
					{{ dashboard_user.numbers.total_number_of_meetings_held }}
				</b>
				<br>
				<span style="font-size: 12px;">
					تعداد کل جلسات برگزارشده
				</span>
			</div>
		</div>
		<!-- **************************************************** -->
		<div class="w-100" style="padding-left: 8px;">
			<div
			class="w-100"
			style="background: #F7E6E7; padding: 11px; border-radius: 20px;"
			>
				<b style="font-size: 24px; color: #AA000C;">
					{{ dashboard_user.numbers.total_number_of_unconfirmed_sessions }}
				</b>
				<br>
				<span style="font-size: 12px;">
					تعدا کل جلسات تایید نشده
				</span>
			</div>
		</div>
		<!-- **************************************************** -->
		<div class="w-100">
			<div
			class="w-100"
			style="background: #EAF5F2; padding: 11px; border-radius: 20px;"
			>
				<b style="font-size: 24px; color: #2AA78D;">
					{{ dashboard_user.numbers.sum_price }}
				</b>
				<span style="font-size: 10px; color: #2AA78D;">
					تومان
				</span>
				<br>
				<span style="font-size: 12px;">
					درآمد کلی شما
				</span>
			</div>
		</div>
	</div>
	<!-- **********----------------------------------****************************************** -->
	 <span v-else>
		<div class=" d-flex" style="justify-content: space-between; margin-bottom: 8px;">
			<div class="w-100" style="padding-left: 8px;">
				<div
				class="w-100"
				style="background: #6767671A; padding: 11px; border-radius: 20px;"
				>
					<b style="font-size: 24px; color: #414042;">
						{{ dashboard_user.numbers.duration_of_cooperation }}
					</b>
					<span style="font-size: 10px; color: #676767;">
						روز
					</span>
					<br>
					<span style="font-size: 12px;">
						مدت زمان همکاری شما
					</span>
				</div>
			</div>
			<div class="w-100" style="padding-left: 8px;">
				<div
				class="w-100"
				style="background: #FFF7E9; padding: 11px; border-radius: 20px;"
				>
					<b style="font-size: 24px; color: #F59B05;">
						{{ dashboard_user.numbers.total_number_of_students }}
					</b>
					<br>
					<span style="font-size: 12px;">
						تعداد کل کاربر‌های شما
					</span>
				</div>
			</div>
		</div>
		<!-- **************************************************** -->
		<div class=" d-flex" style="justify-content: space-between; margin-bottom: 8px;">
			<div class="w-100" style="padding-left: 8px;">
				<div
				class="w-100"
				style="background: #F7E6E7; padding: 11px; border-radius: 20px;"
				>
				<b style="font-size: 24px; color: #AA000C;">
						{{ dashboard_user.numbers.total_number_of_unconfirmed_sessions }}
					</b>
					<br>
					<span style="font-size: 12px;">
						تعدا کل جلسات تایید نشده
					</span>
				</div>
			</div>
			<div class="w-100" style="padding-left: 8px;">
				<div
				class="w-100 text-center"
				style="background: #EAF1F5; padding: 11px; border-radius: 20px;"
			>
				<b style="font-size: 24px; color: #257393;">
					{{ dashboard_user.numbers.total_number_of_meetings_held }}
				</b>
					<br>
					<span style="font-size: 12px;">
						تعداد کل جلسات برگزارشده
					</span>
				</div>
			</div>
		</div>
		<!-- **************************************************** -->
		<div class=" d-flex" style="justify-content: space-between; margin-bottom: 8px;">
			<div class="w-100" style="padding-left: 8px;">
				<div
				class="w-100"
				style="background: #EAF5F2; padding: 11px; border-radius: 20px; height: 76px; display: flex; align-items: center; justify-content: center;"
			>
				<b style="font-size: 24px; color: #2AA78D;">
					{{ dashboard_user.numbers.sum_price }}
				</b>
				<span style="font-size: 10px; color: #2AA78D;">
					تومان
				</span>
				<span style="font-size: 12px;">
					درآمد کلی شما
				</span>
			</div>
		</div>
	</div>
</span>
<div class=" d-flex" style="justify-content: space-between; margin-top: 32px;" :style="(windowWidth>=1000) ? '' : 'flex-direction: column;'">
	<div :style="(windowWidth>=1000) ? 'width: 70%;' : 'width: 100%;'">
		<div class="d-flex">
			<span style="display: flex; align-items: center;">
				جلسات من:
				&nbsp;
			</span>
			<select class="form-control input_sty" v-model="bar_mod" @change="(e)=>{set_bar(e)}" style="background-color: #F5FAFD; height: 24px; padding: 0 10px;">
				<option value="day">
					ماه جاری
				</option>
				<option value="month">
					سال جاری
				</option>
			</select>
		</div>
		<div style="height: 200px;" v-if="bar_show">
			<apexchart type="bar" height="200" :options="chartOptions" :series="series" ></apexchart>
		</div>
	</div>
	<div :style="(windowWidth>=1000) ? 'width: 30%;' : 'width: 100%;'">
		<div class="w-100  border-15 border p-3" style="height: 225px;">
			<div>
				جلسات آتی
			</div>
			<hr>
			<!-- ******** -->
			<div style="overflow-y: auto; height: 140px; direction: ltr; padding-right: 15px;"
		   :style="(dashboard_user.upcoming_events.length==0) ? 
			   `background-repeat: no-repeat;
			  background-position: center;
			  background-size: 252px; 
			  background-image:url(`+require('../../assets/img/calender_empty.svg')+`);`
			  : ''"
			>
				<div v-for="(f, i) in dashboard_user.upcoming_events" :key="i" style="margin-bottom: 24px;">
					<div style="font-size: 10px;">
						جلسه 
						{{ f.category }}
						{{ f.degrees }}
					</div>
					<div class="d-flex justify-content-between" style="font-size: 8px;">
						<span class="list_req">
							{{ f.date_class }}
						</span>
						<span class="list_req" dir="rtl">
							{{ f.time_class.start }}
							تا
							{{ f.time_class.end }}
						</span>
					</div>
				</div>
			</div>
			<!-- ******** -->
		</div>
	</div>
</div>
<!-- *************************************************************************** -->
 <hr>
<div class=" d-flex" style="justify-content: space-between; margin-top: 32px;" :style="(windowWidth>=1000) ? '' : 'flex-direction: column;'">
	<div :style="(windowWidth>=1000) ? 'width: 33%;' : ''">
		<div class="w-100  border-15 border p-3" :style="(windowWidth>=1000) ? 'height: 270px;' : ''">
			<div class="d-flex justify-content-between">
				<span>
					فعالیت های من
				</span>
			</div>
			<hr style="margin: 16px;">
			<apexchart type="pie"  height="220" :options="chartOptions_donut" :series="series_donut"></apexchart>
		</div>
	</div>
	<div class="" style=""  :style="(windowWidth>=1000) ? 'padding-right: 16px; width: 67%;' : 'margin-top: 16px;'">
		<div class="w-100  border-15 border p-3" :style="(windowWidth>=1000) ? 'height: 270px;' : ''">
			<div class="d-flex justify-content-between">
				<span>
					وضعیت درخواست‌های من
				</span>
				<router-link to="/reserved/user/list" class="btn text-success pt-0 pb-0" style="border-radius: 4px;">
					مشاهده همه
				</router-link>
			</div>
			<hr>
			<!-- ******** -->
			<div style="direction: ltr; padding-right: 15px;"
			:style="
			((dashboard_user.my_requests.length==0) ? 'height: 200px;' : ((windowWidth>=1000) ? 'height: 200px;' : '')) 
			+
			((windowWidth>=1000 && dashboard_user.my_requests.length>0) ? 'overflow-y: auto; height: 190px;' : '') 
			+
			((dashboard_user.my_requests.length==0) ? 
			 `background-repeat: no-repeat;
			background-position: center;
			background-size: 252px; 
			background-image:url(`+require('../../assets/img/folder_empty.svg')+`);`
			: '')"
			>
				<table class="table" v-if="windowWidth>=1000 && dashboard_user.my_requests.length>0">
					<thead>
						<tr class="tr-lg">
							<th class="th-lg">
								جزئیات
							</th>
							<th class="th-lg">
								وضعیت جلسه
							</th>
							<th class="th-lg">
								زمان جلسه
							</th>
							<th class="th-lg">
								محل تدریس
							</th>
							<th class="th-lg">
								نام مدرس
							</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="(f, i) in dashboard_user.my_requests" :key="i" class="tr-lg">
							<td class="td-lg">
								<router-link :to="'/reserved/user/'+f.id" class="btn btn-success pt-0 pb-0" style="border-radius: 4px;">
									مشاهده
								</router-link>
							</td>
							<td class="td-lg" :style="'color:'+f.status_color+';'">
								{{ f.status_text }} 
							</td>
							<td class="td-lg" dir="rtl">
								{{ f.date_class }} 
								{{ f.time_class.start }} تا
								{{ f.time_class.end }} 
							</td>
							<td class="td-lg">
								{{ f.knd_class }}
							</td>
							<td class="td-lg">
								{{ f.teacher }}
							</td>
						</tr>
					</tbody>
				</table>
				<span v-else-if="dashboard_user.my_requests.length>0">
					<table 
					dir="rtl" 
					class="table border-bottom" 
					v-for="(f, i) in dashboard_user.my_requests" 
					:key="i"
					style="margin-bottom: 24px;"
					
					>
						<tr>
							<td class="text-success font-weight-bold border-0">
								نام مدرس
							</td>
							<td class=" border-0">
								{{ f.teacher }}
							</td>
						</tr>
						<tr>
							<td class="text-success font-weight-bold border-0">
								محل تدریس
							</td>
							<td class=" border-0">
								{{ f.knd_class }}
							</td>
						</tr>
						<tr>
							<td class="text-success font-weight-bold border-0">
								زمان جلسه
							</td>
							<td class=" border-0">
								{{ f.date_class }} 
								{{ f.time_class.start }} تا
								{{ f.time_class.end }} 
							</td>
						</tr>
						<tr>
							<td class="text-success font-weight-bold border-0">
								وضعیت جلسه
							</td>
							<td class=" border-0">
								{{ f.status_text }} 
							</td>
						</tr>
						<tr>
							<td colspan="2"  class=" border-0" style="padding-bottom: 24px;">
								<router-link :to="'/reserved/user/'+f.id" class="btn btn-success w-100" style="border-radius: 4px;">
									مشاهده
								</router-link>
							</td>
						</tr>
					</table>
					<hr>
				</span>
			</div>
			<!-- ******** -->
		</div>
	</div>
</div>
	</div>
</template>

	<script>
	import VueApexCharts from 'vue-apexcharts'
		
		export default {
			name: 'dashboard_teacher_part1',
			data(){
				return {
					bar_mod: 'day',
					bar_show: true,
					series: [{
						name: '',
						data: []
					}],
					series_donut: [],
					chartOptions_donut: {
						labels: [],
						fill: {
							opacity: 1
						},
						legend: {
							position: 'bottom'
						},
						stroke: {
							width: 1
						},
					},
					chartOptions: {
						chart: {
							type: 'bar',
						},
						plotOptions: {
							bar: {
								borderRadius: 2.5,
								dataLabels: {
									position: 'top',
								},
							}
						},
						dataLabels: {
							enabled: false,
							offsetY: -20,
							style: {
								fontFamily: "IRANSans",
								fontSize: '12px',
							}
						},
						xaxis: {
							categories: [],
							position: 'button',
							crosshairs: {
								fill: {
								type: 'gradient',
								gradient: {
									colorFrom: '#D8E3F0',
									colorTo: '#fc9e00',
									stops: [0, 100],
									opacityFrom: 0.4,
									opacityTo: 0.5,
								}
								}
							},
						},
        			},
					dashboard_user: null,
				}






			},
			components: {
				apexchart: VueApexCharts,
			},
			props: {
			},
			mounted(THIS = this){
				window.$.post(window.baseurl+'dashboard/user', {
					token: this.$localStorage.get("user") 
				 }, function(D){
					THIS.dashboard_user = D.data;
					THIS.series[0].data = THIS.dashboard_user.bar.day
					THIS.chartOptions.xaxis.categories = THIS.dashboard_user.bar.day_e;
					THIS.series_donut = THIS.dashboard_user.my_activities.cnt
					THIS.chartOptions_donut.labels = THIS.dashboard_user.my_activities.category
				}, "json");



			},
			methods:{
				set_bar(e, THIS = this){
					THIS.bar_mod = e.target.value;
					THIS.bar_show = false;
					setTimeout(()=>{
						if(THIS.bar_mod == "day"){
							THIS.series[0].data = THIS.dashboard_user.bar.day
							THIS.chartOptions.xaxis.categories = THIS.dashboard_user.bar.day_e
						}else{
							THIS.series[0].data = THIS.dashboard_user.bar.month
							THIS.chartOptions.xaxis.categories = THIS.dashboard_user.bar.month_e
							console.log(THIS.bar_mod);
						}
						this.bar_show = true;
					},5);

				},
			}
		}
	</script>
<style scoped>
.input_sty{
	width: 254px;
	border: 1px solid #C6C6C6;
	border-radius: 10px;
}








	.list_req{
		font-size: 9px;
		color: #676767;
	}
	.text-12{
		color: #000;
		font-size: 12px;
	}



	::-webkit-scrollbar {
		width: 8px;
		border-radius: 8px;
	  }
	  
	  ::-webkit-scrollbar-track {
		background: #D1D3D4; 
		border-radius: 8px;
	  }
	   
	  /* Handle */
	  ::-webkit-scrollbar-thumb {
		background: #1b60c6; 
		border-radius: 8px;
	  }
	  
	  /* Handle on hover */
	  ::-webkit-scrollbar-thumb:hover {
		background: #fc9e00; 
		cursor: pointer;
	  }
	  .th-lg{
		background-color: white !important;
		font-size: 12px;
		color: #1b60c6 !important;
	  }
	  .td-lg{
		color: #676767;
		font-size: 12px;
	  }
	  .tr-lg:nth-child(even) {
		background: #F5FAFD;
	  }
	hr, .border{
		border: 1px solid #D1D3D4 !important;
	  }
</style>
